<template>
  <div class="mypage-favorite-team-select-page">
    <sub-header-section
      :pageTitle="$tc('MypagePage.MypageFavoriteTeamSelectPage.pageTitle')"
      backLink="/mypage"
    />

    <mypage-favorite-team-select-pane
      class="mypage-favorite-team-select-page__content"
      ref="mypageFavoriteTeamSelectPane"
      @success-regist="moveToMypageTop"
    />

    <action-buttons-section
      scrollTargetSelector=".mypage-favorite-team-select-page__content"
      :visible="true"
    >
      <atom-input-button
        :linkText="$tc('common.set')"
        :isDisabled="false"
        @push="setFavoriteTeam"
      />
    </action-buttons-section>

    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import MypageFavoriteTeamSelectPane from '@/components/MypageFavoriteTeamSelectPage/MypageFavoriteTeamSelectPane.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'

export type DataType = {
  screenTransitionModal: boolean
  screenTransitionTo: string
}

/**
 * マイページ: お気に入りチーム選択ページ
 */
export default defineComponent({
  name: 'MypageFavoriteTeamSelectPage',
  components: {
    SubHeaderSection,
    GlobalNavigationPane,
    MypageFavoriteTeamSelectPane,
    ActionButtonsSection,
    AtomInputButton,
  },
  data(): DataType {
    return {
      screenTransitionModal: false, // 画面遷移警告モーダル表示フラグ
      screenTransitionTo: '', // 画面遷移警告モーダル 遷移先指定
    }
  },
  setup() {
    const mypageFavoriteTeamSelectPane = ref<InstanceType<typeof MypageFavoriteTeamSelectPane>>()
    return {
      mypageFavoriteTeamSelectPane,
    }
  },
  methods: {
    setFavoriteTeam(): void {
      /**
       * 変更確認通知
       */
      this.mypageFavoriteTeamSelectPane?.changeFavoriteTeam()
    },
    /**
     * マイページTOPページに遷移する
     */
    moveToMypageTop(): void {
      this.$router.replace({ path: '/mypage' })
    },
  },
})
</script>
